import type { QueryView } from '@krp/client-runtime'

import { AQSI_RIGHTS } from '../../../shared/model/rights'
import type { DeviceRowVm } from '../../catalog/model/types'

/** Магазин кабинета с его кассами — узел дерева структуры AQSI. */
export interface StructureShopVm {
  /** Ключ магазина кабинета; у касс без магазина — пустая строка. */
  id: string
  name: string
  devices: readonly DeviceRowVm[]
}

/**
 * «Структура AQSI» (таблица замечаний 13.10.2026, п. 9): магазины кабинета и кассы
 * каждого — из снимка касс службы, того же, что в «Номенклатуре».
 */
export interface StructureVm {
  query: QueryView
  /** Когда снят снимок касс и сколько в нём записей; пусто — снимок не прочитан. */
  snapshot: string
  /** «Магазинов: 2, касс: 5»; `null` — снимок не прочитан. */
  summary: string | null
  shops: readonly StructureShopVm[]
  /** Кассы загружаются из кабинета прямо сейчас. */
  refreshing: boolean
  /** Другая команда кабинета ещё идёт — новую не начинаем. */
  busy: boolean
  /** Итог последней загрузки касс: что прочитано или почему нет — текст службы дословно. */
  notice: { kind: 'done' | 'failed'; text: string } | null
}

export interface StructureActions {
  refresh: () => void
  retry: () => void
}

/** Право окна структуры: видеть кассы кабинета. */
export const STRUCTURE_CAPABILITY = AQSI_RIGHTS.devicesRead
